'use client';

import { 
  ControlType, 
  CalculatorId, 
  CalculatorType,
  ControlIds,
  type CalculatorConfig,
  DataTableInputMode,
  type ControlValues,
  type SingleColumnSelectControl
} from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';
import { ModeCalculator } from './mode-calculator';
import { calculateMode } from '../../../lib/stats/mode';

export interface ModeControlValues extends ControlValues {
  [ControlIds.Values]: string;
}

// Define the valuesControl with the correct type
const valuesControl: SingleColumnSelectControl = {
  id: ControlIds.Values,
  type: ControlType.SingleColumnSelect,
  label: 'Select Data Column',
  required: true,
  numericOnly: true,
  defaultValue: 'scores'
};

export const modeControls = {
  tabs: [
    {
      title: 'Data',
      controls: [valuesControl] as const
    }
  ]
};

export const modeCalculatorConfig: CalculatorConfig<CalculatorId.MODE> = {
  id: CalculatorId.MODE,
  type: CalculatorType.Graph,
  name: 'Mode Calculator',
  dataTableInputMode: DataTableInputMode.Required,
  initialData: TableDataJSON.from({
    columns: [
      { 
        id: 'scores',
        name: 'Test Scores', 
        values: ['85', '90', '85', '88', '92', '85', '91', '88', '86', '85'] 
      },
      {
        id: 'sizes',
        name: 'Shoe Sizes',
        values: ['8', '9', '8.5', '8', '9', '8', '7.5', '8', '9', '8.5']
      },
      {
        id: 'ratings',
        name: 'Product Ratings',
        values: ['4', '5', '4', '3', '4', '5', '4', '4', '5', '4']
      }
    ]
  }),
  initialControlValues: {
    [ControlIds.Values]: 'scores'
  },
  controls: modeControls,
  getInitialConfig: (data: TableDataJSON) => ({
    [ControlIds.Values]: data.columns[0]?.id || ''
  }),
  getVisualizationData: (params: { data: TableDataJSON; controls: ControlValues }) => {
    const columnId = params.controls[ControlIds.Values] as string;
    const values = params.data.columns
      .find(col => col.id === columnId)
      ?.values
      .map(v => Number(v))
      .filter(v => !isNaN(v));
    
    if (!values || values.length === 0) return null;
    return calculateMode(values);
  },
  render: ({ visualizationData }) => <ModeCalculator visualizationData={visualizationData} />
}; 